import { MediaType } from './MediaType';
import { ExternalSource } from './Source';

export enum BiAddMediaActionTarget {
  Import = 'import',
  Upload = 'upload',
  More = 'more',
  UploadDragAndDrop = 'upload_drag_and_drop',
  CurrentFolderDragAndDrop = 'current_folder_drag_and_drop',
  FolderDragAndDrop = 'folder_drag_and_drop',
  BreadcrumbDragAndDrop = 'breadcrumb_drag_and_drop',
  Copy = 'copy',
  CropEdit = 'crop_edit',
  VideoMaker = 'video-maker',
  WixVideoLibrary = 'wix_video_library',
  AdobeExpress = 'adobe',
}

export enum BiAddMediaClickOrigin {
  FullSize = 'full_size',
  Minimized = 'minimized',
  DragAndDrop = 'drag_and_drop',
  ImportFilesTabs = 'import_files_tabs',
  AddMediaContributorsHint = 'add_media_contributors_hint',
  AddMediaBarTop = 'add_media_bar_top',
  NewUpload = 'new_upload',
  StartAdding = 'start_adding',
  EmptyFolder = 'empty_folder_or_filter',
  UploadWidget = 'upload_widget',
  ContextMenu = 'context_menu',
  SideBar = 'sideBar',
  FirstTime = 'firstTime',
  UploadingViewDetails = 'uploading_view_details',
  AutoOpen = 'auto_open',
  WixVideoLibrary = 'wix_video_shortcut',
  AdobeExpress = 'adobe',
}

export enum OpenSource {
  VideoMaker = 'video-maker',
}

export interface IBiAddMediaFileInfo {
  correlationId: string;
  batchId: string;
  batch: boolean;
  batchSize: number;
  clickOrigin: BiAddMediaClickOrigin;
  target: BiAddMediaTarget;
  fileFormat?: string;
  fileOrigin?: string;
  mediaType?: MediaType;
  startedTime?: number;
  isTags?: boolean;
}

export enum BIPageName {
  MediaManager = 'Media Manager',
  StorageManager = 'Storage Manager',
}

export type BiAddMediaTarget = BiAddMediaActionTarget | ExternalSource;

export enum ActionName {
  AddToFavorites = 'add_to_favorites',
  RemoveFromFavorites = 'remove_from_favorites',
  RemoveFromBoard = 'remove_from_board',
  Rename = 'rename',
  CropEdit = 'crop_edit',
  Adjust = 'adjust',
  CutOut = 'cut_out',
  EditInAdobeExpress = 'adobe',
  Preview = 'preview',
  ShowInfo = 'show_info',
  HideInfo = 'hide_info',
  MoveTo = 'move_to',
  Copy = 'copy',
  Cut = 'cut',
  Paste = 'paste',
  PasteHere = 'paste_here',
  Download = 'download',
  Restore = 'restore',
  DeleteForever = 'delete_forever',
  DeleteForeverUsed = 'delete_forever_used',
  DeleteForeverUnused = 'delete_forever_unused',
  EmptyTrash = 'empty_trash',
  MoveToTrash = 'move_to_trash',
  CreateFolder = 'create_folder',
  AddFilesToFolder = 'add_files_to_folder',
  SortChange = 'sort_change',
  LayoutChange = 'layout_change',
  CopyUrl = 'copy_url',
  CopyWixUrl = 'copy_wix_url',
  CreateVideo = 'create_video',
  ReEdit = 're_edit',
  ChangeBackground = 'background',
}
